/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keys',
    pure: false,
})
export class KeysPipe implements PipeTransform {
    public transform(value: any, args: any[] = null): any {
        return Object.keys(value);
    }
}
